module.exports = __webpack_public_path__ + "static/media/img_fjords_wide.79a9052d.jpg";